<!-- Zweck: Stellt die HTML-Struktur für shop view action component im Frontend bereit. -->
<div class="shop-view-action" [class.in-row]="row_mode">
  <div class="shop-view-action-element">
    <shop-entry-edit-fields
      [artikel]="artikel"
      [view]="getView()"
      [viewcomp]="viewcomp"
      [vertreterconfig]="vertreterconfig"
      [(entry)]="entry"
      [islastavailable]="islastavailable"
      (mengeKeydownEnter)="mengeEnter()"
      >
    </shop-entry-edit-fields>
  </div>

  @if (view && view.settings && (inDetailsView || !view.settings.bestellblock_mode)
    && !isActionHidden('warenkorb')) {
    <div class="shop-view-action-element shop-view-action-element-no-margin">
      <warenkorb-button [artikel]="artikel" [disabled]="disabled" [entry]="entry"
        [view_slug]="getViewSlug()"
        [vertreterconfig]="vertreterconfig"
      ></warenkorb-button>
    </div>
  }

  @if (!isActionHidden('sonderpreis')) {
    <div class="shop-view-action-element" hasPermission [allOfRoles]="['Vertreter', 'Kundensonderpreis Verwaltung']">
      <customer-special-price-edit-button [artikel]="artikel" [disabled]="disabled"></customer-special-price-edit-button>
    </div>
  }

  @if (!isActionHidden('verfuegbarkeit')) {
    <div class="shop-view-action-element">
      <verfuegbarkeits-info-button [artikel]="artikel" [disabled]="disabled" [entry]="entry"
      [view]="getView()" class="tut_shopview_artvf"></verfuegbarkeits-info-button>
    </div>
  }

  @if (!isActionHidden('nichtverfuegbarkeits_pdf')) {
    <div class="shop-view-action-element">
      <feature-block [features]="['Nichtverfuegbarkeitsabfrage']">
        <permission-block [oneOfRoles]="['Nichtverfügbarkeitsabfrage']">
          @if (showNotAvailableButton$ | async) {
            @if (!(notAvailablePdfLoading | async)) {
              <button mat-icon-button type="button" matTooltip="Nichtverfügbarkeits-PDF erzeugen"
                (click)="generateNotAvailablePdf()">
                <svg-icon>nichtverfuegbarkeitsabfrage</svg-icon>
              </button>
            } @else {
              <button mat-icon-button type="button" disabled aria-label="Nichtverfügbarkeits-PDF wird erzeugt">
                <mat-spinner [diameter]="24"></mat-spinner>
              </button>
            }
          }
        </permission-block>
      </feature-block>
    </div>
  }

  @if (getView().artikelstamm == 1 && !isActionHidden('alternativartikel')) {
    <div class="shop-view-action-element">
      <feature-block [features]="['ArtikelKlassifizierungSuche']">
        <alternativ-artikel-button [artikel]="artikel" [view]="getView()" class="tut_shopview_alternativ_button"></alternativ-artikel-button>
      </feature-block>
    </div>
  }

  @if (!isActionHidden('kontakt')) {
    <div class="shop-view-action-element">
      <contact-button [artikel]="artikel" [view]="getView()" class="tut_shopview_contact" [asbutton]="true"></contact-button>
    </div>
  }

  @if (!isActionHidden('merkliste')) {
    <div class="shop-view-action-element">
      <merkliste-button [artikel]="artikel" [disabled]="disabled" [entry]="entry" [view_slug]="getViewSlug()"
      class="tut_shopview_artml"></merkliste-button>
    </div>
  }
</div>
